import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import CertificateEditor from "@/components/CertificateEditor";

// Determine API URL: use localhost when accessed from localhost (Playwright),
// otherwise use the configured backend URL for external access
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API = isLocalhost 
  ? 'http://localhost:8001'  // Direct backend access for Playwright
  : (window.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001');

/**
 * Dedicated page for server-side certificate rendering
 * This page is loaded by Playwright to capture the certificate as an image
 */
const CertificateRender = () => {
  const [searchParams] = useSearchParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const serial = searchParams.get('serial');
        if (!serial) {
          console.error('No serial number provided');
          window.certificateError = 'No serial number provided';
          return;
        }

        // Fetch certificate data
        const response = await fetch(`${API}/api/verify/${serial}`);
        if (!response.ok) {
          throw new Error(`Failed to fetch certificate: ${response.status} ${response.statusText}`);
        }
        const verifyData = await response.json();
        
        // Fetch template data
        const templateResponse = await fetch(`${API}/api/templates/${verifyData.certificate.template_id}`);
        if (!templateResponse.ok) {
          throw new Error(`Failed to fetch template: ${templateResponse.status} ${templateResponse.statusText}`);
        }
        const templateData = await templateResponse.json();
        
        setData({
          certificate: verifyData.certificate,
          recipient: verifyData.recipient,
          issuer: verifyData.issuer,
          template: templateData
        });
        
        // Signal that rendering is ready
        window.certificateReady = true;
        setLoading(false);
      } catch (error) {
        console.error('Error loading certificate:', error);
        window.certificateError = error.message;
      }
    };

    fetchData();
  }, [searchParams]);

  if (loading || !data) {
    return (
      <div style={{ 
        width: '1056px', 
        height: '816px', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center',
        background: 'white'
      }}>
        <div>Loading certificate...</div>
      </div>
    );
  }

  const { certificate, recipient, template } = data;

  // Use certificate's custom layout if available, otherwise use template's layout
  const layout = certificate.template_layout || template.layout;

  return (
    <div id="certificate-container" style={{ 
      width: '1056px', 
      height: '816px', 
      overflow: 'hidden',
      background: 'white'
    }}>
      <CertificateEditor
        templateBackground={template.background_url ? `${API}/api/proxy-image?url=${encodeURIComponent(template.background_url)}` : null}
        onSave={() => {}}
        logoPreview={certificate.logo_base64 || null}
        instructorName={certificate.instructor_name}
        courseName={certificate.course_name}
        recipientName={recipient.name}
        completionDate={recipient.completion_date}
        serialNumber={recipient.serial_number}
        initialLayout={layout}
        isCustomBackground={true}
        readOnly={true}
      />
    </div>
  );
};

export default CertificateRender;
